// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-content-lcNJnL{width:180px;color:var(--light-color-grey-grey-8,#2e3238);font-size:12px;font-style:normal;font-weight:400;line-height:18px}.tip-content-lcNJnL li{list-style-type:disc}.markdown-_4u8z3 p{margin:4px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tip-content": `tip-content-lcNJnL`,
	"tipContent": `tip-content-lcNJnL`,
	"markdown": `markdown-_4u8z3`
};
export default ___CSS_LOADER_EXPORT___;
